<template>
  <div class="container old-globals">
    <nav-bar />
    <div class="outer-container">
      <side-nav
        :has-back-button="true"
        :back-label="backLabel"
        @onBack="returnToAssignmentsOrCases()"
      />
      <grading-reports :id="caseId" />
    </div>
  </div>
</template>

<script>
import SideNav from '~lib/common/components/SideNav';
import NavBar from '~lib/common/components/NavBar';

import GradingReports from '../components/grading/GradingReports';

export default {
  name: 'cases-screen',
  components: {
    GradingReports,
    SideNav,
    NavBar,
  },
  computed: {
    caseId() {
      return this.$route.params.id;
    },
    backLabel() {
      if (this.$router.currentRoute.query.assignmentId) {
        return 'Return to assignments';
      } else {
        return 'Return to scenarios';
      }
    },
  },
  methods: {
    returnToAssignmentsOrCases() {
      if (this.fromPath === '/cases' || this.fromPath === '/assignments') {
        this.$router.go(-1);
      } else {
        if (this.$router.currentRoute.query.assignmentId) {
          this.$router.push({ name: 'assignments' });
        } else {
          this.$router.push({ name: 'cases' });
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.fromPath = from.fullPath;
    });
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.outer-container {
  flex: 1 0 0;
  display: flex;
  flex-direction: row;
  overflow: auto;
}
</style>
